package com.cs.ejobin.utils

object Validators {
    fun isValidPhone(phone: String): Boolean {
        val p = phone.trim()
        return p.length >= 8
    }

    fun isStrongEnoughPassword(pw: String): Boolean = pw.length >= 6
}